import React, { useEffect, useState } from 'react';
import {
  Nav,
  NavLink,
  NavbarContainer,
  Span,
  NavLogo,
  NavItems,
  ButtonContainer,
  MobileIcon,
  MobileMenu,
  MobileLink
} from './NavbarStyledComponent';
import { DiCssdeck } from 'react-icons/di';
import { FaBars, FaMoon, FaSun } from 'react-icons/fa';
import { useTheme } from '../../themes/Themes';

const NAV_SECTIONS = ['about', 'skills', 'experience', 'projects', 'publications', 'education'];

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [activeSection, setActiveSection] = useState('');
  const { darkMode, setDarkMode, theme } = useTheme();

  // Active section via IntersectionObserver
  useEffect(() => {
    const observers = [];
    const sectionMap = {};

    NAV_SECTIONS.forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          sectionMap[id] = entry.isIntersecting;
          // Pick topmost visible section
          const active = NAV_SECTIONS.find((s) => sectionMap[s]) || '';
          setActiveSection(active);
        },
        { rootMargin: '-80px 0px -40% 0px', threshold: 0 }
      );
      observer.observe(el);
      observers.push(observer);
    });

    return () => observers.forEach((obs) => obs.disconnect());
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.mobile-menu') && !event.target.closest('.mobile-icon')) {
        setIsOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <Nav>
      <NavbarContainer>
        <NavLogo to='/'>
          <span style={{ 
            display: "flex", 
            alignItems: "center", 
            color: theme?.colors?.text || theme?.text_primary,
            marginBottom: 0, 
            cursor: 'pointer' 
          }}>
            <DiCssdeck size="3rem" /> <Span>{'Aniket Vyavhare'}</Span>
          </span>
        </NavLogo>
        <MobileIcon className="mobile-icon">
          <FaBars onClick={() => setIsOpen(!isOpen)} />
        </MobileIcon>
        <NavItems>
          <NavLink href="#about" active={activeSection === 'about' ? 1 : 0}>About</NavLink>
          <NavLink href='#skills' active={activeSection === 'skills' ? 1 : 0}>Skills</NavLink>
          <NavLink href='#experience' active={activeSection === 'experience' ? 1 : 0}>Experience</NavLink>
          <NavLink href='#projects' active={activeSection === 'projects' ? 1 : 0}>Projects</NavLink>
          <NavLink href='#publications' active={activeSection === 'publications' ? 1 : 0}>Publications</NavLink>
          <NavLink href='#education' active={activeSection === 'education' ? 1 : 0}>Education</NavLink>
        </NavItems>
        <ButtonContainer>
          {/* Dark/Light Mode Toggle Button */}
          <button
            style={{
              background: darkMode ? '#181824' : '#f2f2f2',
              border: `2px solid ${theme?.primary || '#854CE6'}`,
              cursor: 'pointer',
              fontSize: 16,
              color: darkMode ? '#a78bfa' : '#7c3aed',
              borderRadius: '20px',
              padding: '8px 16px',
              boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
              transition: 'all 0.2s',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '12px',
            }}
            onClick={() => setDarkMode((prev) => !prev)}
            aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
            title={darkMode ? "Switch to light mode" : "Switch to dark mode"}
          >
            {darkMode ? <FaSun /> : <FaMoon />}
          </button>
        </ButtonContainer>
        {
          isOpen &&
          <MobileMenu className="mobile-menu" isOpen={isOpen}>
            <MobileLink href="#about" active={activeSection === 'about' ? 1 : 0} onClick={() => setIsOpen(false)}>About</MobileLink>
            <MobileLink href='#skills' active={activeSection === 'skills' ? 1 : 0} onClick={() => setIsOpen(false)}>Skills</MobileLink>
            <MobileLink href='#experience' active={activeSection === 'experience' ? 1 : 0} onClick={() => setIsOpen(false)}>Experience</MobileLink>
            <MobileLink href='#projects' active={activeSection === 'projects' ? 1 : 0} onClick={() => setIsOpen(false)}>Projects</MobileLink>
            <MobileLink href='#publications' active={activeSection === 'publications' ? 1 : 0} onClick={() => setIsOpen(false)}>Publications</MobileLink>
            <MobileLink href='#education' active={activeSection === 'education' ? 1 : 0} onClick={() => setIsOpen(false)}>Education</MobileLink>
          </MobileMenu>
        }
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
